let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5m29h")]).then(() => parcelRequire('8VQU1'));